import { FC } from 'react';
import { CustomIconButton } from '@retail/components';
import { Check, Clear } from '@mui/icons-material';
import { Stack } from '@mui/material';

interface Props {
  disableOnSubmit?: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

export const ConfirmEditButtons: FC<Props> = ({ disableOnSubmit, onSubmit, onCancel }) => (
  <Stack flexDirection="row">
    <CustomIconButton
      disabled={disableOnSubmit}
      onClick={onSubmit}
      icon={<Check fontSize="small" />}
    />
    <CustomIconButton onClick={onCancel} icon={<Clear fontSize="small" />} />
  </Stack>
);
